import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    deleteDobovoApartment,
    fetchDobovoApartments,
    importDobovoApartments,
    postDobovoApartment
} from '../../../../../api/dobovoApi/dobovoApartments'
import { selectApartments, selectApartmentsFetching } from '../../../../../selectors/dobovoSelectors/dobovoApartments'
import { selectCurrentOrganization } from '../../../../../selectors/dobovoSelectors/dobovoCurrentOrganization'
import { selectEasymsOrganizations } from '../../../../../selectors/easymsOrganizationSelector'
import ApartmentsTable from './ApartmentsTable'

const TabContainer = props => (
    <Typography component="div" style={{ padding: 8 * 3 }}>
        {props.children}
    </Typography>
)

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 150,
        textAlign: 'left'
    },
    menu: {
        width: 150
    },
    margin: {
        margin: theme.spacing.unit
    }
})

class ApartmentsTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        apartments: PropTypes.array.isRequired,
        fetching: PropTypes.bool.isRequired,
        fetchDobovoApartments: PropTypes.func.isRequired,
        postDobovoApartment: PropTypes.func.isRequired,
        deleteDobovoApartment: PropTypes.func.isRequired,
        importDobovoApartments: PropTypes.func.isRequired,
        currentOrganization: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }

    componentDidMount() {
        const params = { remoteOrganizationId: this.props.currentOrganization }
        this.props.fetchDobovoApartments(params)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentOrganization !== this.props.currentOrganization) {
            const params = { remoteOrganizationId: this.props.currentOrganization }
            this.props.fetchDobovoApartments(params)
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleDelete = remoteApartmentsId => {
        this.props.deleteDobovoApartment(remoteApartmentsId)
    }

    handleLoadImport = () => {
        this.props.importDobovoApartments()
    }

    handleUpdate = apartment => {
        this.props.postDobovoApartment({
            ourOrganizationId: apartment.ourOrganizationId,
            ourOrganizationName: this.props.easymsOrganizations[apartment.ourOrganizationId].name,
            remoteApartmentsId: apartment.remoteApartmentsId,
            remoteApartmentsName: apartment.remoteApartmentsName,
            remoteOrganizationId: apartment.remoteOrganizationId,
            ourCategoryId: apartment.ourCategoryId,
            rateId: apartment.rateId,
            active: apartment.active
        })
    }

    render() {
        const { classes, fetching, apartments, currentOrganization } = this.props

        return (
            <div className={classes.root}>
                <div className={classes.root}>
                    <Button
                        disabled={!currentOrganization}
                        variant="raised"
                        color="primary"
                        className={classes.button}
                        onClick={this.handleLoadImport}
                    >
                        Импортировать апартаменты c Dobovo.com
                    </Button>
                </div>

                {fetching ? (
                    <CircularProgress className={classes.progress} />
                ) : (
                    <ApartmentsTable
                        apartments={apartments}
                        onDelete={this.handleDelete}
                        onUpdate={this.handleUpdate}
                    />
                )}
            </div>
        )
    }
}

export default connect(
    state => ({
        apartments: selectApartments(state),
        fetching: selectApartmentsFetching(state),
        currentOrganization: selectCurrentOrganization(state),
        easymsOrganizations: selectEasymsOrganizations(state)
    }),
    { fetchDobovoApartments, postDobovoApartment, deleteDobovoApartment, importDobovoApartments }
)(withStyles(styles, { withTheme: true })(ApartmentsTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/ApartmentsTab/ApartmentsTab.js